module.exports = __webpack_public_path__ + "static/contact-56bcd6e1dc0089c8f5138342e392544c.mp4";